export default "__VITE_ASSET__BDq7vkuL__"